module.exports = __webpack_public_path__ + "static/media/cart-list.a671d942.svg";